import { useQuery } from '@apollo/client'
import React from 'react'
import {
  ClearanceStatusFilterInput,
  GetClearanceStatus,
  GetClearanceStatusVariables,
} from '../../types'
import { GET_CLEARANCE_STATUS } from './operations'

interface Props {
  filter: ClearanceStatusFilterInput
  page?: number
  pageLength?: number
}

const PAGE_LENGTH = 10

const NEW_DATE = new Date()

export const useClearanceStatus = ({ filter, page = 1, pageLength = PAGE_LENGTH }: Props) => {
  const { createdAt, groupIds, nameOrClearanceIdLike } = filter || {}
  const queryVariables = React.useMemo<GetClearanceStatusVariables>(() => {
    return {
      filterData: {
        nameOrClearanceIdLike,
        createdAt: createdAt ? createdAt : NEW_DATE,
        groupIds,
      },
      pagination: {
        from: pageLength * (page - 1) || 0,
        length: pageLength,
      },
    }
  }, [createdAt, nameOrClearanceIdLike, groupIds, page, pageLength])
  const clearanceStatuses = useQuery<GetClearanceStatus, GetClearanceStatusVariables>(
    GET_CLEARANCE_STATUS,
    {
      variables: queryVariables,
    }
  )
  return clearanceStatuses
}
